import React from 'react';

export const Break = () => <div style={{ display: 'block', height: '24px', width: '100%' }}></div>
